module.exports = {
	"Announcement": {
		"Know More": "Meer weten"
	},
	"Appointment": {
		"Conditions": "By clicking on “Confirm” you confirm you have read the privacy policy and consent to the processing of your personal data by %(brand)s in the conditions set forth in the privacy policy to answer your request.",
		"Confirmation": "Wij hebben uw aanvraag voor een afspraak in de winkel met één van onze adviseurs in behandeling genomen, voor op uw wensen afgestemde hulp. Een bevsteigingsmail zal u binnenkort worden toegezonden.",
		"Description": "Dior nodigt u uit om een afspraak in de winkel met één van onze adviseurs te maken voor op uw wensen afstemde hulp.",
		"Get an appointment": "Een afspraak maken",
		"Motives": "Redenen",
		"Universes": "Wereld"
	},
	"DiorMap": {
		"Search in this area": "In dit gebied zoeken"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Resultaat",
			"other": "%(count)s Resultaten",
			"zero": "%(count)s Resultaat"
		},
		"Refine": "Verfijnen",
		"RefineAria": "Refine search with the checkboxes below",
		"Are you looking for?": "Bent u Zoekt u een winkel met damesmode, herenmode, kindermode, sieraden of horloges?"
	},
	"Footer": {
		"Download the applications": "Download the applications",
		"Language": "Language",
		"Newsletter": "e.g. Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "Sign up for the Newsletter"
	},
	"Form": {
		"All fields are mandatory": "All fields are required",
		"Civility": "Beleefde groeten",
		"Comments": "Opmerkingen",
		"Conditions": "Als u een bevestiging per e-mail van Christian Dior Couture wilt ontvangen, vink dan het bovenstaande vakje aan. U beschikt over het recht tot inzage van, rectificatie van, wissen van en bezwaar tegen de verwerking van gegevens die u betreffen en u kunt dit uitoefenen door te schrijven naar contact@dior.com",
		"Date": "Gewenste data",
		"Email": "E-mail adres",
		"Hour": "Gewenste uren ",
		"Invalid E-mail address": "Invalid E-mail address",
		"Mr": "Mr",
		"Mrs": "Mrs",
		"Name": "Naam",
		"Phone": "Telefoon",
		"Required fields": "Required fields",
		"Submit": "Bevestigen",
		"Surname": "Voornaam"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Dior Boetieks in uwstad: haute couture, parfums, lederwaren",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Aankomst",
		"Departure": "Vertrek",
		"Details": "Details",
		"Error": "Het spijt ons, we hebben de gevraagde route niet gevonden, probeert u het nog eens door het adres van vertrek en/of het gebruikte vervoermiddel te wijzigen",
		"Follow the itinerary": "De route volgen",
		"Itinerary": "Route",
		"modeBICYCLING": "Switch to bicycling",
		"modeDRIVING": "Switch to driving",
		"modeTRANSIT": "Switch to transit",
		"modeWALKING": "Switch to walking",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Please use your phone in portrait mode"
	},
	"NavMobile": {
		"Home": "Home"
	},
	"Newsletter": {
		"Dior Newsletter": "Dior Newsletter",
		"Fashion and accessories": "Fashion & Accessories",
		"I wish to receive the %(newsletter)s newsletter": "I wish to receive %(newsletter)s news",
		"Newsletter Confirmation": "You have successfully signed up for the newsletter",
		"Perfume and beauty": "Fragrance & Beauty",
		"Receive our newsletter": "Receive our newsletter",
		"Your universes": "Your areas of interest"
	},
	"ResultsBlock": {
		"Dior boutiques": "Dior winkels",
		"Too far": "Te veel resultaten, verfijn je zoekopdracht door een kleiner zoekgebied te kiezen.",
		"No result": "No shop could be found",
		"Other shops": "Andere winkels",
		"Results": "Search results",
		"Fewer results, zoom in": "Minder resultaten, zoom in",
		"More results, zoom out": "Meer resultaten, zoom out",
		"Fewer results": "Minder resultaten",
		"More results": "Meer resultaten"
	},
	"SearchBlock": {
		"Geolocation": "Use geolocation to find stores near you",
		"Search": "Zoeken"
	},
	"Share": {
		"Conditions": "By clicking on “Confirm” you confirm you have read the privacy policy and consent to the processing of your personal data by %(brand)s in the conditions set forth in the privacy policy to answer your request. If you tick the appropriate box, you also consent to the processing of your personal data by Christian Dior Couture for direct marketing, which my be tailored based on the personal data we know about you and your preferences.",
		"Recipient": "Uw geadresseerde",
		"Share Confirmation": "De productinformatie van uw winkel is nu verzonden",
		"Share this shop": "Share the store details",
		"Your favorite shop": "Uw favoriete winkel"
	},
	"ShopBlock": {
		"Closed": "Gesloten",
		"Closed today": "Closed today",
		"Directions": "Route",
		"DirectionsAria": "Directions to %(shopName)s",
		"Make an appointment": "Afspraak maken",
		"Open": "Open",
		"Opening time": "Openingstijden",
		"OpeningAria": "More information on the Opening hours",
		"ResultNumber": "Result number %(number)s",
		"Services": "Diensten",
		"ServicesAria": "More information on the Services",
		"Share": "Share",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Vandaag tot en met %(hour)s",
		"Universes": "Wereld",
		"UniversesAria": "More information on the related Universes",
		"and": "and",
		"from": "from",
		"publicHolidays": "The boutique is probably closed",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/nl_be/translations.json
// module id = 870
// module chunks = 0